import { SalesInsightsSeriesEntry } from '../models/sales-insights.model';

export interface SalesInsightsProgressInput {
  value: number | null | undefined;
  target: number | null | undefined;
}

export interface SalesInsightsProgressBar {
  valuePercent: number;
  targetPercent: number | null;
  attainment: number | null;
  reached: boolean;
}

export function salesInsightsSeriesTargets(entries: SalesInsightsSeriesEntry[]): number[] | null {
  if (!entries.some(entry => entry.target !== null && entry.target !== undefined)) {
    return null;
  }
  return entries.map(entry => entry.target ?? null) as number[];
}

// One scale for every row, the largest of all values and targets, so the bars compare between rows and the tick at
// 100 % of each row's target lands where that target is on the scale.
export function salesInsightsProgressScale(rows: SalesInsightsProgressInput[]): number {
  return rows.reduce((max, row) => Math.max(max, Math.abs(row.value ?? 0), Math.abs(row.target ?? 0)), 0);
}

export function salesInsightsProgressBar(row: SalesInsightsProgressInput, scale: number): SalesInsightsProgressBar {
  const value = row.value ?? 0;
  const hasTarget = row.target !== null && row.target !== undefined && row.target > 0;
  const toPercent = (amount: number) => (scale > 0 ? Math.min(100, Math.max(0, (amount / scale) * 100)) : 0);
  const attainment = hasTarget ? (value / (row.target as number)) * 100 : null;
  return {
    valuePercent: toPercent(value),
    targetPercent: hasTarget ? toPercent(row.target as number) : null,
    attainment,
    reached: attainment !== null && attainment >= 100
  };
}
